<div class="investidores m-4 p-0 ">
  <div class="group-cards">
    <div class="cards-top">
      <icons-primecap name="pasta"></icons-primecap>
      <div class="group-info-top">
        <p class="text-aux">Quantidade de Investidores</p>
        <p class="info">{{ quantidadeInvestidores }}</p>
      </div>
    </div>
    <div class="cards-top">
      <icons-primecap name="dollar"></icons-primecap>
      <div class="group-info-top">
        <p class="text-aux">Investidores Ativos</p>
        <p class="info">{{ investidoresAtivos }}</p>
      </div>
    </div>
  </div>
  <div class="investidores-container">
    <div class="info-investidores">
      <div class="group-investidores-top">
        <icons-primecap name="users"></icons-primecap>
        <p class="info p-bold">Investidores</p>
      </div>
      <hr class="divisor">
      <div class="lista-investidores">

        <app-tabela-crud *ngIf="this.tipoUsuario == tipoUsuarioEnum.ASSESSOR"
          [definicaoColuna]="colunasTabela"
          [dadosTabela]="listaInvestidor"
          [exibirBusca]="false"
          [exibirColunaCrud]="true"
          [exibirDashboard]="true"
          [exibirDetalhes]="true"
          [habilitarPaginacaoNoBackend]="true"
          [definicaoConfigPagina]="configPagina"
          (paginacao)="mudarPagina($event)"
          (acaoCrud)="redirecionarDetalhesInvestidor($event)"
          (acaoExtra)="executarAcaoExtra($event)">
        </app-tabela-crud>

        <app-tabela-crud *ngIf="this.tipoUsuario == tipoUsuarioEnum.ESCRITORIO"
          [definicaoColuna]="colunasTabela"
          [dadosTabela]="listaInvestidor"
          [exibirBusca]="false"
          [habilitarPaginacaoNoBackend]="true"
          [definicaoConfigPagina]="configPagina"
          (paginacao)="mudarPagina($event)">
        </app-tabela-crud>
      </div>
    </div>
  </div>
</div>
